import { useGetCurrentUser } from '@front/auth/src/authentication-context';

import {
  getIsBookingForSelf,
  getIsInstantTaxCreditSelected,
} from '@front/common/src/ducks/customer/basket-selectors';
import { useAppSelector } from '@front/common/src/store/store';

export type UseIsITCSelectedOrSuccessfullyPairedReturn = {
  isInstantTaxCreditSelected: boolean | undefined;
  isITCSelectedOrSuccessfullyPaired: boolean;
  isWecasaCarePairingSuccessful: boolean;
  shouldShowTaxCreditPriceInfo: boolean;
};

export const useIsITCSelectedOrSuccessfullyPaired = (): UseIsITCSelectedOrSuccessfullyPairedReturn => {
  const user = useGetCurrentUser();
  const isInstantTaxCreditSelected = useAppSelector(getIsInstantTaxCreditSelected);
  const isWecasaCarePairingSuccessful = user?.wecasa_care_pairing_status === 'successful';
  const isForSelf = useAppSelector(getIsBookingForSelf);
  // isBookingForSelf is undefined when customer screen is skipped during account creation — treat as for self
  const isBookingForSelf = isForSelf === undefined || isForSelf;
  const isITCSelectedOrSuccessfullyPaired =
    isBookingForSelf && (isWecasaCarePairingSuccessful || isInstantTaxCreditSelected);
  return {
    isInstantTaxCreditSelected,
    isITCSelectedOrSuccessfullyPaired: isITCSelectedOrSuccessfullyPaired ?? false,
    isWecasaCarePairingSuccessful,
    shouldShowTaxCreditPriceInfo: isBookingForSelf,
  };
};
